import React from 'react';
import { Navigate } from 'react-router-dom';
import { redirectUnlessInventory } from '../../utils/moduleAccess';
import { Form, FormGroup, FormControl, Button, Modal, Row, Col } from 'react-bootstrap';
import config from '../../../config';
import { handleFocusInScrollField, INVENTORY_MODAL_BODY_SCROLL_STYLE } from './invKeyboardScroll';
import SharedDataTable from '../../_components/Shared/SharedDataTable';
import ReactPaginate from 'react-paginate';
import moment from 'moment';
import utils from '../../utils';
import DatacoLoadingIndicator from '../../_components/DatacoLoadingIndicator';

let perPage = 30;

class MasterLocation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: 0,
            area: '',
            locationCode: '',
            locationDescription: '',
            locations: [],
            areas: [],
            body: [],
            pageCount: 0,
            keyword: '',
            filterArea: '',
            modalShow: false,
            newMode: false,
            offset: 0,
        };

        this.columns = [
            {
                name: 'Actions',
                cell: (row, rowIndex) => (
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'nowrap', minWidth: '180px', paddingRight: '10px' }}>
                        <button
                            style={{ whiteSpace: 'nowrap', minWidth: '70px', padding: '6px 12px', fontSize: '14px', fontWeight: '500', flexShrink: 0 }}
                            type="button"
                            onClick={() => this.onClickLocationSelected(null, row, rowIndex)}
                        >
                            Edit
                        </button>
                        <button
                            style={{ whiteSpace: 'nowrap', minWidth: '70px', padding: '6px 12px', fontSize: '14px', fontWeight: '500', flexShrink: 0 }}
                            type="button"
                            onClick={() => window.confirm("Are you sure you delete this data?") && this.onDeleteLocation(null, row, rowIndex)}
                        >
                            Delete
                        </button>
                    </div>
                ),
                ignoreRowClick: true,
                allowOverflow: true,
                width: '180px',
                minWidth: '180px',
            },
            {
                name: 'Area',
                selector: row => row.area || '',
                sortable: true,
                maxWidth: '300px',
                width: '300px',
            },
            {
                name: 'Location Code',
                selector: row => row.locationCode || '',
                sortable: true,
                maxWidth: '150px',
                width: '150px',
            },
            {
                name: 'Location Description',
                selector: row => row.locationDescription || '',
                sortable: true,
                maxWidth: '500px',
                width: '500px',
            },
        ];
        this.handlePageClick = this.handlePageClick.bind(this);
    }

    componentDidMount() {
        this.fetchAreas();
        this.buildHtmlTable();
    }

    fetchAreas() {
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };

        fetch(`${config.apiUrl}/getAreas`, requestOptions)
            .then((response) => {
                return response.text().then(text => {
                    const data = text && JSON.parse(text);
                    return data;
                });
            })
            .then(areas => {
                if (areas) {
                    this.setState({ areas: areas });
                }
            })
            .catch(error => {
                console.error('Error fetching areas:', error);
                this.setState({ areas: [] });
            });
    }

    exportExcel() {
        utils.tableToExcel('master-location-export-table', 'masterlocation', 'MasterLocation_' + moment().format('YYYYMMDD') + '.xls');
    }

    buildHtmlTable() {
        this.setState({ loading: true });
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };

        if (localStorage.getItem('user') != null) {
            const user = JSON.parse(localStorage.getItem('user'));
            let url = `${config.apiUrl}/getMasterLocations?company=${user.accountId}`;
            
            if (this.state.filterArea) {
                url += `&area=${encodeURIComponent(this.state.filterArea)}`;
            }

            return fetch(url, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);
                        return data;
                    });
                })
                .then(body => {
                    let array = [];
                    const locations = [];

                    if (body && Array.isArray(body)) {
                        // Filter by keyword if provided
                        let filteredData = body;
                        if (this.state.keyword && this.state.keyword.trim() !== '') {
                            const keyword = this.state.keyword.toLowerCase();
                            filteredData = body.filter(item => 
                                (item.locationCode && item.locationCode.toLowerCase().includes(keyword)) ||
                                (item.locationDescription && item.locationDescription.toLowerCase().includes(keyword)) ||
                                (item.area && item.area.toLowerCase().includes(keyword))
                            );
                        }

                        // Sort by area, then locationCode
                        filteredData.sort((a, b) => {
                            const areaCompare = (a.area || '').localeCompare(b.area || '');
                            if (areaCompare !== 0) return areaCompare;
                            return (a.locationCode || '').localeCompare(b.locationCode || '');
                        });

                        // Pagination
                        const offset = this.state.offset || 0;
                        const paginatedData = filteredData.slice(offset, offset + perPage);
                        const pageCount = Math.ceil(filteredData.length / perPage);

                        paginatedData.map((data, index) => {
                            array.push({
                                no: index + offset + 1,
                                id: data.id,
                                area: data.area || '',
                                locationCode: data.locationCode || '',
                                locationDescription: data.locationDescription || '',
                                company: data.company || 0
                            });
                        });

                        this.setState({
                            locations: array,
                            body: filteredData,
                            pageCount: pageCount,
                            loading: false
                        });
                    } else {
                        this.setState({
                            locations: [],
                            body: [],
                            pageCount: 0,
                            loading: false
                        });
                    }
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                    this.setState({ locations: [], body: [], pageCount: 0, loading: false });
                });
        }
    }

    onClickLocationSelected(cell, row, rowIndex) {
        const safeString = (val) => {
            if (val == null || val === undefined) return '';
            const str = String(val);
            return str === 'null' || str === 'undefined' ? '' : str;
        };
        const safeNumber = (val) => {
            if (val == null || val === undefined || val === '') return 0;
            const num = Number(val);
            return isNaN(num) ? 0 : num;
        };

        this.setState({
            newMode: false,
            id: safeNumber(row.id),
            area: safeString(row.area),
            locationCode: safeString(row.locationCode),
            locationDescription: safeString(row.locationDescription),
        }, () => {
            setTimeout(() => {
                this.setState({ modalShow: true });
            }, 0);
        });
    }

    onDeleteLocation(cell, row, rowIndex) {
        fetch(`${config.apiUrl}/deleteMasterLocation`, {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: row.id,
            })
        })
            .then((response) => {
                if (response.status == 200) {
                    window.alert('Deleted Successfully.');
                    this.buildHtmlTable();
                } else {
                    response.json().then(data => {
                        window.alert(data.error || 'Failed to delete location.');
                    });
                }
            })
            .catch(error => {
                console.error('Error deleting location:', error);
                window.alert('Failed to delete location.');
            });
    }

    handlePageClick(data) {
        let selected = data.selected;
        let offset = Math.ceil(selected * perPage);
        this.setState({ offset: offset }, () => {
            this.buildHtmlTable();
        });
    }

    checkLocationDescriptionUnique = async (area, locationDescription, excludeId = null) => {
        if (!locationDescription || locationDescription.trim() === '') {
            return true; // Empty descriptions are allowed
        }

        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };

        if (localStorage.getItem('user') != null) {
            const user = JSON.parse(localStorage.getItem('user'));
            const url = `${config.apiUrl}/getMasterLocations?company=${user.accountId}&area=${encodeURIComponent(area)}`;
            
            try {
                const response = await fetch(url, requestOptions);
                const text = await response.text();
                const locations = text ? JSON.parse(text) : [];
                
                if (Array.isArray(locations)) {
                    const duplicate = locations.find(loc => 
                        (excludeId === null || loc.id !== excludeId) &&
                        loc.locationDescription && 
                        loc.locationDescription.trim().toLowerCase() === locationDescription.trim().toLowerCase()
                    );
                    
                    return !duplicate; // Return true if no duplicate found
                }
            } catch (error) {
                console.error('Error checking location description uniqueness:', error);
                // If check fails, allow the operation (backend will validate)
                return true;
            }
        }
        
        return true;
    }

    render() {
        const accessDenied = redirectUnlessInventory(localStorage.getItem('user'));
        if (accessDenied) return accessDenied;

        let { keyword, filterArea, modalShow, newMode, locations, areas, body } = this.state;
        
        const safeString = (val) => (val !== undefined && val !== null) ? String(val) : '';

        const area = safeString(this.state.area);
        const locationCode = safeString(this.state.locationCode);
        const locationDescription = safeString(this.state.locationDescription);

        let handleClose = () => {
            this.setState({
                modalShow: false,
                id: 0,
                area: '',
                locationCode: '',
                locationDescription: '',
            });
        };

        let handleSave = async () => {
            if (!window.confirm("Are you sure you want to update this data?")) return;

            if (!area || !locationCode) {
                window.alert('Area and Location Code are required.');
                return;
            }

            // Check if location description is unique for this area
            const isUnique = await this.checkLocationDescriptionUnique(area, locationDescription, this.state.id);
            if (!isUnique) {
                window.alert(`Location Description must be unique for each area. A location with this description already exists in area "${area}".`);
                return;
            }

            fetch(`${config.apiUrl}/updateMasterLocation`, {
                method: "post",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: this.state.id,
                    area,
                    locationCode,
                    locationDescription,
                })
            })
                .then((response) => {
                    if (response.status == 200) {
                        window.alert('Update Successfully.');
                        this.setState({ modalShow: false });
                        this.buildHtmlTable();
                    } else {
                        return response.json().then(data => {
                            window.alert(data.error || 'Failed to update location.');
                        });
                    }
                })
                .catch(error => {
                    console.error('Error updating location:', error);
                    window.alert('Failed to update location.');
                });
        }

        let handleCreate = async () => {
            if (!area || !locationCode) {
                window.alert('Area and Location Code are required.');
                return;
            }

            // Check if location description is unique for this area
            const isUnique = await this.checkLocationDescriptionUnique(area, locationDescription);
            if (!isUnique) {
                window.alert(`Location Description must be unique for each area. A location with this description already exists in area "${area}".`);
                return;
            }

            const user = JSON.parse(localStorage.getItem('user'));
            fetch(`${config.apiUrl}/createMasterLocation`, {
                method: "post",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    area,
                    locationCode,
                    locationDescription,
                    company: user.accountId
                })
            })
                .then((response) => {
                    if (response.status == 200) {
                        this.setState({ modalShow: false, newMode: false });
                        window.alert('New data created successfully.');
                        this.buildHtmlTable();
                    } else {
                        return response.json().then(data => {
                            window.alert(data.error || 'Failed to create location.');
                        });
                    }
                })
                .catch(error => {
                    console.error('Error creating location:', error);
                    window.alert('Failed to create location.');
                });
        }

        return (
            <div className="container">
                <div style={{
                    marginBottom: '20px',
                    position: 'relative',
                    minHeight: '50px',
                    padding: '16px',
                    margin: '16px 0'
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        flexWrap: 'wrap',
                        padding: '12px'
                    }}>
                        <FormGroup controlId="formInlineKeyword">
                            <FormControl
                                type="text"
                                placeholder="Search..."
                                onChange={ev => { this.setState({ keyword: ev.target.value }) }}
                                value={keyword || ''}
                                style={{ minWidth: '200px' }}
                            />
                        </FormGroup>
                        <FormGroup controlId="formInlineArea">
                            <FormControl
                                as="select"
                                value={filterArea || ''}
                                onChange={ev => { 
                                    this.setState({ filterArea: ev.target.value, offset: 0 }, () => {
                                        this.buildHtmlTable();
                                    });
                                }}
                                style={{ minWidth: '180px' }}
                            >
                                <option value="">All Areas</option>
                                {areas.map((areaItem) => (
                                    <option key={areaItem.id} value={areaItem.name}>{areaItem.name}</option>
                                ))}
                            </FormControl>
                        </FormGroup>
                        <Button
                            bsStyle="primary"
                            onClick={e => this.buildHtmlTable()}>Search</Button>
                        <Button
                            bsStyle="primary"
                            onClick={e => this.exportExcel()}>Export</Button>
                        <Button
                            bsStyle="danger"
                            onClick={e => {
                                this.setState({
                                    id: 0,
                                    area: '',
                                    locationCode: '',
                                    locationDescription: '',
                                    newMode: true,
                                    modalShow: true
                                });
                            }}>New</Button>
                    </div>
                    <a id='dlink' style={{ display: 'none' }}></a>
                </div>
                <div id="datatable" className="container">
                    <SharedDataTable
                        columns={this.columns}
                        data={locations || []}
                        progressPending={this.state.loading}
                        progressComponent={<DatacoLoadingIndicator loading={this.state.loading} size="compact" label="Loading locations" />}
                        pagination={false}
                    />
                </div>
                {/* Hidden export table for Excel */}
                <div id="master-location-export-table" style={{ display: 'none' }}>
                    <table border="1" style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th style={{ padding: '6px' }}>No</th>
                                <th style={{ padding: '6px' }}>Area</th>
                                <th style={{ padding: '6px' }}>Location Code</th>
                                <th style={{ padding: '6px' }}>Location Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(body || []).map((item, index) => (
                                <tr key={item.id || index}>
                                    <td style={{ padding: '4px' }}>{index + 1}</td>
                                    <td style={{ padding: '4px' }}>{item.area || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.locationCode || ''}</td>
                                    <td style={{ padding: '4px' }}>{item.locationDescription || ''}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {this.state.pageCount > 1 && (
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                        <ReactPaginate
                            previousLabel={'previous'}
                            nextLabel={'next'}
                            breakLabel={'...'}
                            breakClassName={'break-me'}
                            pageCount={this.state.pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={this.handlePageClick}
                            containerClassName={'pagination'}
                            subContainerClassName={'pages pagination'}
                            activeClassName={'active'}
                        />
                    </div>
                )}
                {modalShow && (
                    <Modal size="lg" show={modalShow} onHide={handleClose}
                        aria-labelledby="example-modal-sizes-title-lg" dialogClassName="modal-90w"
                        key={`modal-${this.state.id || 'new'}`}>
                        <Modal.Header closeButton>
                            {newMode ? (<Modal.Title>New Location</Modal.Title>) : (<Modal.Title>Edit Master Location</Modal.Title>)}
                        </Modal.Header>
                        <Modal.Body style={INVENTORY_MODAL_BODY_SCROLL_STYLE} onFocusCapture={handleFocusInScrollField}>
                            <div>
                                <Form>
                                    <Row>
                                        <Col sm={12}>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Area <span style={{ color: 'red' }}>*</span></Form.Label></Col>
                                                <Col sm={9}>
                                                    <FormControl 
                                                        as="select" 
                                                        value={area} 
                                                        onChange={(e) => {
                                                            this.setState({ area: e.target.value });
                                                        }}
                                                        required
                                                    >
                                                        <option value="">Select Area</option>
                                                        {areas.map((areaItem) => (
                                                            <option key={areaItem.id} value={areaItem.name}>{areaItem.name}</option>
                                                        ))}
                                                        {/* Ensure FG Delivery is always available as an area option */}
                                                        {!areas.find(a => a.name === 'FG Delivery') && (
                                                            <option value="FG Delivery">FG Delivery</option>
                                                        )}
                                                    </FormControl>
                                                </Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Location Code <span style={{ color: 'red' }}>*</span></Form.Label></Col>
                                                <Col sm={9}>
                                                    <FormControl 
                                                        type="text" 
                                                        onChange={ev => { this.setState({ locationCode: ev.target.value }) }} 
                                                        value={locationCode}
                                                        required
                                                    />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup className="row" as={Row} style={{ marginBottom: '15px' }}>
                                                <Col sm={3}><Form.Label>Location Description</Form.Label></Col>
                                                <Col sm={9}>
                                                    <FormControl 
                                                        as="textarea" 
                                                        rows={3} 
                                                        onChange={ev => { this.setState({ locationDescription: ev.target.value }) }} 
                                                        value={locationDescription} 
                                                    />
                                                </Col>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Cancel
                            </Button>
                            {newMode && (<Button variant="primary" onClick={handleCreate}>
                                Create
                            </Button>)}
                            {!newMode && (<Button variant="primary" onClick={handleSave}>
                                Save Changes
                            </Button>)}
                        </Modal.Footer>
                    </Modal>
                )}
            </div>
        );
    }
}

export { MasterLocation };
